import { SVGProps } from 'react';

export const UploadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg data-icon xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 13C5.66863 13 5.4 12.7354 5.4 12.4091V2.01749L1.02426 6.32693C0.789949 6.55769 0.41005 6.55769 0.175736 6.32693C-0.0585785 6.09616 -0.0585785 5.72202 0.175736 5.49126L5.57574 0.173073C5.81005 -0.0576925 6.18995 -0.0576925 6.42426 0.173073L11.8243 5.49126C12.0586 5.72202 12.0586 6.09616 11.8243 6.32693C11.5899 6.55769 11.2101 6.55769 10.9757 6.32693L6.6 2.01749V12.4091C6.6 12.7354 6.33137 13 6 13Z"
      fill="currentColor"
    />
  </svg>
);
